import styles from "../HealthChat.module.css";
import { useState } from "react";

const CARE_TYPES = [
  { id: "gynecology", label: "Gynecologist", emoji: "🩺", bg: "#fce4ec", specialties: ["gynecologist", "hormonal"], price: 60 },
  { id: "endocrinologist", label: "Endocrinologist", emoji: "🧬", bg: "#fff3e0", specialties: ["hormonal", "endocrinology"], price: 75 },
  { id: "mental_health", label: "Mental Health Expert", emoji: "🧠", bg: "#e1f5fe", specialties: ["psychology", "mental-health"], price: 70 },
  { id: "emergency", label: "Emergency Consult", emoji: "🚨", bg: "#ffebee", specialties: ["urgent-care"], price: 120 },
];

export default function ConsultTypeScreen({ onSelect, onBack }) {
  const [selectedCare, setSelectedCare] = useState(null);
  const [search, setSearch] = useState("");

  // Filter cards based on search
  const filteredCareTypes = CARE_TYPES.filter((c) =>
    c.label.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className={styles.consultTypeScreen}>
      <button className={styles.selectCareBack} onClick={onBack}>
        ← Back
      </button>

      <div className={styles.consultTypeBotRow}>
        <img
          src="/images/chatbotFemCare.svg"
          alt="bot"
          width={52}
          height={52}
          className={styles.consultTypeBotImg}
        />
        <div className={styles.consultTypeBotBubble}>
          I can help you book an appointment. What type of care do you need?
        </div>
      </div>

      {/* Search Box */}
      <div className={styles.selectCareSearchWrap}>
        <span className={styles.selectCareSearchIcon}>🔍</span>
        <input
          className={styles.selectCareSearch}
          placeholder="Search care type..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        {/* Dropdown Results */}
        {search && (
          <div className={styles.selectCareDropdown}>
            {filteredCareTypes.length > 0 ? (
              filteredCareTypes.map((c) => (
                <div
                  key={c.id}
                  className={styles.selectCareDropdownItem}
                  onClick={() => {
                    setSelectedCare(c); // Update selection
                    setSearch("");      // Close dropdown
                  }}
                >
                  <span>{c.emoji}</span>
                  <span>{c.label}</span>
                </div>
              ))
            ) : (
              <div className={styles.selectCareDropdownItem}>No results found</div>
            )}
          </div>
        )}
      </div>

      {/* Cards Grid */}
      <div className={styles.consultTypeGrid}>
        {CARE_TYPES.map((c) => (
          <div
            key={c.id}
            // Add a highlighted class if this card is selected
            className={`${styles.consultTypeCard} ${selectedCare?.id === c.id ? styles.cardSelected : ""}`}
            style={{
              border: selectedCare?.id === c.id ? "2px solid #007bff" : "2px solid transparent",
              transform: selectedCare?.id === c.id ? "scale(1.02)" : "scale(1)"
            }}
            onClick={() => setSelectedCare(c)}
          >
            <div
              className={styles.consultTypeIconCircle}
              style={{ background: c.bg }}
            >
              <span className={styles.consultTypeEmoji}>{c.emoji}</span>
            </div>
            <div className={styles.consultTypeLabel}>{c.label}</div>
          </div>
        ))}
      </div>

      {/* Floating Continue Button */}
      {/* {selectedCare && ( */}
      
        <div className={styles.continueBtnWrapper}>
          <button 
          disabled={!selectedCare}
            className={styles.visitModelContinueBtn} 
            onClick={() => onSelect(selectedCare)}
          >
            Continue with {selectedCare?.label}
          </button>
        </div>
      {/* )} */}
    </div>
  );
}